import * as actionTypes from './actionTypes';

export const initPropertyManagerStart = () => {
  return {
    type: actionTypes.INIT_PROPERTY_MANAGER_START
  };
}

export const initPropertyManagerTenantDetailsStart = (filter) => {
  return {
    type: actionTypes.INIT_PROPERTY_MANAGER_TENANT_DETAILS_START,
    filter
  }
}

export const getPropertyManagerDetails = (single) => {
  return {
    type: actionTypes.GET_PROPERTY_MANAGER_DETAILS,
    single: single
  }
}

export const setPropertyManagerDetails = (info) => {
  return {
    type: actionTypes.SET_PROPERTY_MANAGER_DETAILS,
    propertyManager: info
  };
}

export const setPropertyManagerSuccess = () => {
  return {
    type: actionTypes.SET_PROPERTY_MANAGER_SUCCESS
  };
}

export const setPropertyManagerFailed = () => {
  return {
    type: actionTypes.SET_PROPERTY_MANAGER_FAILED
  };
}

export const getPropertyManagerTenantDetails = (filter, search, page, size) => {
  // console.log('WHAT IS ALL STUFF', filter, search, page, size)
  return {
    type: actionTypes.GET_PROPERTY_MANAGER_TENANT_DETAILS,
    filter: filter,
    search: search,
    page: page,
    size: size

  }
}

export const setPropertyManagerTenantDetails = (info) => {
  return {
    type: actionTypes.SET_PROPERTY_MANAGER_TENANT_DETAILS,
    response: info
  }
}

export const setPropertyManagerTenantDetailsSuccess = () => {
  return {
    type: actionTypes.SET_PROPERTY_MANAGER_TENANT_DETAILS_SUCCESS
  }
}

export const setPropertyManagerTenantDetailsFailed = () => {
  return {
    type: actionTypes.SET_PROPERTY_MANAGER_TENANT_DETAILS_FAILED
  }
}



export const restoreServiceTenantAccount = (routerMac, masterAccNum, cmsPayload) => {
  const { tenantName, propertyName, tenantAccountNumber, tenantAccountDivisionId, tenantAccountRouterMac, bulkMasterAccount } = cmsPayload
  return {
    type: actionTypes.RESTORE_SERVICE_TENANT_ACCOUNT,
    // SCL needs these
    routerMac,
    masterAccNum,
    // These are needed to send the restore message to CMS
    tenantName,
    propertyName,
    tenantAccountNumber,
    tenantAccountDivisionId,
    tenantAccountRouterMac,
    bulkMasterAccount
  }
}

export const restoreServiceTenantAccountSuccess = () => {
  return {
    type: actionTypes.RESTORE_SERVICE_TENANT_ACCOUNT_SUCCESS
  }
}

export const restoreServiceTenantAccountFailed = () => {
  return {
    type: actionTypes.RESTORE_SERVICE_TENANT_ACCOUNT_FAILED
  }
}

export const resumeSpecReadyServiceTenantAccount = (routerMac, masterAccNum) => {
  return {
    type: actionTypes.RESUME_SPEC_READY_SERVICE_TENANT_ACCOUNT,
    routerMac,
    masterAccNum
  }
}

export const resetPropertyManagerFlags = () => ({ type: actionTypes.RESET_PROPERTY_MANAGER_FLAGS });

